// ** Redux Imports
import { createSlice, createAsyncThunk,current } from "@reduxjs/toolkit";
import { Menudata } from "@assets/data/menu";
import { EnableDisableMenus } from "@assets/data/menuRules";
import {
  GetProbateStatus,
  Logout,
  GetCaseStatus,
  GetShouldSoaDisabled,
} from "@api";

import useJwt from "@src/auth/useJwt";

const config = useJwt.jwtConfig; // don't remove this line even if unused
export const logoutUser = createAsyncThunk("landing/logout", async (args) => {
  const response = await Logout();
  return response.data;
});

export const getCaseStatus = createAsyncThunk(
  "/common/get_casestatus",
  async (args) => {
    const response = await GetCaseStatus(args);
    return response.data;
  }
);

export const getProbateStatus = createAsyncThunk(
  "/common/status",
  async (args) => {
    const response = await GetProbateStatus(args);
    return response.data;
  }
);

export const getShouldSoaDisabled = createAsyncThunk(
  "common/get_should_soa_disbaled",
  async (args) => {
    const response = await GetShouldSoaDisabled(args);
    return response.data;
  }
);

export const stepsSlice = createSlice({
  name: "steps",
  initialState: {
    menus: Menudata,
    selectedMenu: Menudata[0],
    max: Menudata.length,
    previousMenu: "",
    nextMenu: Menudata[1],
    completedMenuId: -1,
    //disabledMenu: [],
    loading: false,
    isSubmitted: false,
    hasElitCaseNo: false,
    hasGrantSucceed: false,
    hasLateSOA: false,
    hasDocumentRejected: false,
    SOAStatus: 0,
    hasPendingOAuth: false,
    caseStatus: "",
    soaDisable: false,
  },
  reducers: {
    moveToNextMenu: (state, action) => {
      let counter = state.selectedMenu.id + 1;
      if (counter >= state.max) counter = state.max;
      state.previousMenu =
        counter === 1 ? "" : state.menus.find((o) => o.id === counter - 1);
      if (
        !state.selectedMenu ||
        (state.selectedMenu && state.selectedMenu.id !== counter)
      )
        state.selectedMenu = state.menus.find((o) => o.id === counter);
      if (counter > state.completedMenuId) state.completedMenuId = counter;
      state.nextMenu =
        counter + 1 > state.max
          ? ""
          : state.menus.find((o) => o.id === counter + 1);
    },
    moveToPreviousMenu: (state, action) => {
      const step = 1;
      // state.selectedMenu.id === 6 && state.disabledMenu.length > 0 ? 2 : 1;
      let counter = state.selectedMenu.id - step;
      if (counter === 0) counter = 1;
      state.previousMenu =
        counter === 1 ? "" : state.menus.find((o) => o.id === counter - step);
      if (
        !state.selectedMenu ||
        (state.selectedMenu && state.selectedMenu.id !== counter)
      )
        state.selectedMenu = state.menus.find((o) => o.id === counter);
      state.nextMenu =
        counter + step > state.max
          ? ""
          : state.menus.find((o) => o.id === counter + step);
    },
    moveToCurrentMenu: (state, action) => {
      var currentIndex = state.menus.findIndex(
        (o) => action.payload.route.indexOf(o.route) !== -1
      );

      if (currentIndex !== -1) {
        const counter = currentIndex + 1;
        state.previousMenu =
          counter === 1 ? "" : state.menus.find((o) => o.id === counter - 1);
        if (
          !state.selectedMenu ||
          (state.selectedMenu && state.selectedMenu.id !== counter)
        )
          state.selectedMenu = state.menus.find((o) => o.id === counter);
        state.nextMenu =
          counter + 1 > state.max
            ? ""
            : state.menus.find((o) => o.id === counter + 1);
      }
    },
    showLoader: (state, action) => {
      state.loading = action.payload;
    },
    hideLoader: (state, action) => {
      state.loading = action.payload;
    },
    updateIsSubmitted: (state, action) => {
      state.isSubmitted = action.payload;
      state.menus = EnableDisableMenus(...state);
    },
    updateElitCaseNo: (state, action) => {
      state.hasElitCaseNo = action.payload;
    },
    updateGrantSucceess: (state, action) => {
      state.hasGrantSucceed = action.payload;
      state.menus = EnableDisableMenus(state);
    },
    updateLateSOA: (state, action) => {
      state.hasLateSOA = action.payload;
    },
    updatePendingSOA: (state, action) => {
      state.SOAStatus = action.payload;
    },
    updatePreviousBtnDisabled: (state, action) => {
      state.previousMenu.disabled = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getProbateStatus.fulfilled, (state, action) => {
        state.isSubmitted = action.payload.isSubmitted;
        state.hasElitCaseNo = action.payload.hasElitCaseNo;
        state.hasGrantSucceed = action.payload.hasGrantSucceed;
        state.SOAStatus = action.payload.soaStatus;
        state.hasLateSOA = action.payload.hasLateSOA;
        state.completedMenuId = action.payload.completedMenuId;
        state.hasPendingOAuth = action.payload.hasPendingOAuth;
        state.hasDocumentRejected = action.payload.hasDocumentRejected;
        state.hasPendingMainSubmissionPayment =
          action.payload.hasPendingMainSubmissionPayment;
        state.menus = EnableDisableMenus(state);
        //console.log(current(state));
        // const soaIndex = state.disabledMenu.indexOf(5);
        // if (action.payload.isSoaSubmitted) {
        //   state.disabledMenu.splice(soaIndex, 1);
        // } else {
        //   if (soaIndex === -1) state.disabledMenu.push(5);
        // }
      })
      .addCase(getCaseStatus.fulfilled, (state, action) => {
        state.caseStatus = action.payload.caseStatus;
      })
      .addCase(getShouldSoaDisabled.fulfilled, (state, action) => {
        state.soaDisable = action.payload.soaDisable;
        state.menus = EnableDisableMenus(state);
      });
  },
});

export const {
  moveToNextMenu,
  moveToPreviousMenu,
  moveToCurrentMenu,
  showLoader,
  hideLoader,
  updateIsSubmitted,
  updateElitCaseNo,
  updateGrantSucceess,
  updateLateSOA,
  updatePendingSOA,
  updatePreviousBtnDisabled,
} = stepsSlice.actions;

export default stepsSlice.reducer;
